module.exports = __webpack_public_path__ + "img/missionaries17_2019_7-7-2021.d8a73213.jpg";